import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('DataSota root element was not found.');

createRoot(rootElement).render(<App />);
window.__DATASOTA_READY__ = true;
document.documentElement.dataset.appReady = 'true';
